export default "__VITE_ASSET__408cec10__"